/*
  生产环境配置
*/
export default {
    ssoServiceUser: 'https://itsmops.autoai.com/usercenter/sso/operator/www/v1/', // 用户登录
    ssoService: 'https://wedof.autoai.com/', // 用户验证码和key
    baseURL:"https://itsmops.autoai.com/itsm/v1/",                                // 业务接口
    BASE_API: 'https://itsmops.autoai.com/',                                      // 上传
    // roleUrl:"https://itsmauth.autoai.com/",           // 权限
    roleUrl:"https://wedof-auth.autoai.com/", // 新权限
    BASEURL:"https://itsmops.autoai.com/",         //CICD关联
    sseurl:"https://itsmops.autoai.com/itsm/stream",
    // ssoService: '//itsmauth.autoai.com/',
    // AuthUrl:"http://wedof-authority.beta.autoai.com/authority/v1/",  //请求新权限系统
    AuthUrl: "https://wedof-auth.autoai.com/authority/v1/",                                // 用户权限管理
    timeout: 30000,
    withCredentials: true,
    filterUser:'https://wedof.autoai.com/',//搜索人员接口域名
    pageTitle: 'vue管理系统后台模版',
};


